import { ISite } from './ISite';
import { SiteNaturfagsmaraton } from './SiteNaturfagsmaraton';
import { SiteSciencedysten } from './SiteScienceDysten';

export function getSite(): ISite {   
    if (window.location.href.toLowerCase().indexOf('naturfagsmarat') > 0) {
        return new SiteNaturfagsmaraton();
    }
    if (window.location.href.toLowerCase().indexOf('sciencedysten') > 0) {
        return new SiteSciencedysten();
    }
    return new SiteNaturfagsmaraton();
}

export function isTestSite(): boolean {
    return window.location.href.toLowerCase().indexOf('test.') > 0;
}

export function isDemoSite(): boolean {
    return window.location.href.toLowerCase().indexOf('demo') > 0;
}

export function isDriftSite(): boolean {
    const url = window.location.href.toLowerCase();

    const result = url.indexOf('test.') === -1 && url.indexOf('localhost') === -1 && url.indexOf('demo') === -1;
    return result;
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/infrastructure/site/SiteProvider.ts